import { useContext, useEffect, useRef } from "react";
import { CInputText, CInputPassword, BtnLoader, PageLoader, toast } from "../../components/widget";
import { Link, useNavigate } from 'react-router-dom';
import { LoginApi } from "../../api";
import { ContextLoading } from "../../context";

export const Login = () => {
    const navigate = useNavigate();
    const formRef: any = useRef()
    const CtxLoad = useContext(ContextLoading)

    const handelLogin = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await LoginApi(formRef)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.data.status == "OK") {
            localStorage.setItem('user', JSON.stringify(res.data.data[0]))
            localStorage.setItem('token', res.data.data[0].token)
            navigate('/p/dashboard');
        }
        else {
            toast(res.data.message, { type: "error" })
        }
    }


    useEffect(() => {
        document.title = "ورود | دایان"
        CtxLoad.setDisplayLoading(true)
        const timer = setTimeout(() => {
            if (localStorage.getItem('token')) {
                navigate('/p/dashboard');
                CtxLoad.setDisplayLoading(false)
            }
            else {
                CtxLoad.setDisplayLoading(false)
            }
        }, 1500);
        return () => clearTimeout(timer);
    }, [])

    return (
        <>
            {CtxLoad.displayLoading && <PageLoader />}
            <div className=" w-full min-h-screen bg-dayan-gray-50 flex justify-center items-center">
                <div className="w-full sm:w-[400px]  flex flex-col items-center">
                    <img src="/assetes/logo/logo.png" alt="logo" className=" w-[120px]" />
                    <div className=" w-[94%] sm:w-full mt-[10px] flex flex-col items-center justify-center rounded-xl shadow bg-white py-[30px] px-[20px]">
                        <form ref={formRef} onSubmit={handelLogin} className=" w-full ">
                            <CInputText custom_class="Cltr" name="email" title="پست الکترونیکی" type="email" required={true} />
                            <CInputPassword custom_class="Cltr" name="password" title="رمز عبور" required={true} />
                            {CtxLoad.displayLoadingBtn ?
                                <button type="button" className=" w-full h-[40px] sm:h-[45px] text-white text-xs font-bold rounded-[5px] bg-dayan-gray-100 flex justify-center items-center cursor-not-allowed"><BtnLoader /></button>
                                :
                                <button type="submit" className=" w-full h-[40px] sm:h-[45px] text-white text-xs font-bold rounded-[5px] bg-dayan-gray-100">ورود به کنترل پنل</button>
                            }
                        </form>
                        <Link to={'/forget'} className="mt-[20px]">
                            <span className=" text-dayan-gray-100 text-xs cursor-pointer ">کلمه عبور خود را فراموش کرده اید ؟</span>
                        </Link>
                        <Link to={'/register'} className="mt-[20px]">
                        <span className=" text-dayan-gray-100 text-sm cursor-pointer mt-[20px]">حساب کاربری ندارید ؟</span>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}
